export default __webpack_public_path__ + "static/media/property_233.6eec3e4a.png";